/* SNEAP collection: filter drawer, auto-apply filters & sorting, load more */
(function () {
  var S = (window.SNEAP = window.SNEAP || {});
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var panel = root.querySelector('[data-sn-filters]');
    var ov = root.querySelector('[data-sn-filter-overlay]');
    var openBtn = root.querySelector('[data-sn-filter-open]');
    var form = root.querySelector('[data-sn-filter-form]');
    var sort = root.querySelector('[data-sn-sort]');

    function isSidebar() { return root.classList.contains('sn-col--sidebar') && window.matchMedia('(min-width: 990px)').matches; }
    function open() {
      if (!panel) return;
      panel.classList.add('is-open'); ov.classList.add('is-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      S.lock(panel, openBtn);
      setTimeout(function () { var c = panel.querySelector('[data-sn-close]'); if (c) c.focus(); }, 60);
    }
    function close() {
      if (!panel || !panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open'); ov.classList.remove('is-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      S.unlock(panel);
    }
    if (openBtn) openBtn.addEventListener('click', open);
    if (ov) ov.addEventListener('click', close);
    if (panel) panel.querySelectorAll('[data-sn-close]').forEach(function (b) { b.addEventListener('click', function () { if (pending) apply(); else close(); }); });

    /* Build the URL from the form + sort and go there */
    var pending = false, t;
    function apply() {
      var base = form ? form.getAttribute('action') : window.location.pathname;
      var params = new URLSearchParams();
      if (form) {
        new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '' && k !== 'sort_by') params.append(k, v); });
      } else {
        new URLSearchParams(window.location.search).forEach(function (v, k) { if (k !== 'sort_by' && k !== 'page') params.append(k, v); });
      }
      if (sort && sort.value) params.set('sort_by', sort.value);
      window.location.assign(base + (params.toString() ? '?' + params.toString() : ''));
    }
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('[data-sn-price-input]')) { pending = true; clearTimeout(t); t = setTimeout(apply, 900); return; }
        if (isSidebar() || !panel.classList.contains('is-open')) apply();
        else pending = true; /* in the drawer: apply when "Show results" is tapped */
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); apply(); });
    }
    if (sort) sort.addEventListener('change', apply);

    /* Load more */
    root.addEventListener('click', function (e) {
      var more = e.target.closest('[data-sn-more]');
      if (!more) return;
      e.preventDefault();
      if (more.classList.contains('is-busy')) return;
      more.classList.add('is-busy');
      var label = more.textContent;
      more.textContent = '…';
      fetch(more.href, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(root.id) || doc.querySelector('[data-sn-collection]');
          var grid = root.querySelector('[data-sn-grid]');
          if (fresh && grid) {
            var items = fresh.querySelectorAll('[data-sn-grid] > li');
            items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
            var wrap = root.querySelector('[data-sn-more-wrap]');
            var nwrap = fresh.querySelector('[data-sn-more-wrap]');
            if (wrap && nwrap) wrap.innerHTML = nwrap.innerHTML; else if (wrap) wrap.remove();
            if (window.history && history.replaceState) history.replaceState({}, '', more.href);
          } else {
            window.location.href = more.href;
          }
        })
        .catch(function () { window.location.href = more.href; })
        .finally(function () { more.classList.remove('is-busy'); more.textContent = label; });
    });
  }
  function boot() { document.querySelectorAll('[data-sn-collection]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
